import { css } from 'linaria';

export const sectionStyle = css`
  box-sizing: border-box;
  width: 100%;
`;
